import { defineFcm } from '../shared/factory';

export const FCM_PROMOTED_PETITIONS_DISABLE_USER_SIGNATURE_FETCH = defineFcm(
	'promoted_petitions_disable_user_signature_fetch',
)
	.asBoolean()
	.withDefault(false)
	.toConfig();
